// Libs
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

// Components
import {
  ExpandableGroupHeader,
  ExpandableCard
} from '@ibinder/common-frontend';

// Utils
import { getGroupOfCards } from '@ibinder/common-utils';
import {
  actionMenu,
  inspectionTypeName
} from './inspectionTypeTransformations';

// Components
import InspectionTypeCardDetails from './InspectionTypeCardDetails';

// Styles
const Wrapper = styled.main`
  margin: 0 -1rem;
`;

const CardsWrapper = styled.section`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 0 1rem;
  margin-top: -0.5rem;

  > * {
    width: calc(50% - 1rem);
  }
`;

const InspectionTypeCardList = ({
  queryData,
  selectedIds,
  selectItem,
  selectItems,
  groupCheckStatus,
  groupBy,
  onActionSelect,
  workflowTemplateList,
  canUseInspectionIssuesWithWorkflow
}) => {
  const { t } = useTranslation();

  const renderCards = (inspectionTypes) => {
    return inspectionTypes.map((inspectionType, i) => {
      const templateName = workflowTemplateList?.find((workflowTemplate) => 
        workflowTemplate.Key === inspectionType.workflowTemplateId
      )?.Value;
      return(
      <ExpandableCard
        cardAction={actionMenu(onActionSelect, t)(inspectionType.id)}
        key={i}
        onSelectCallback={selectItem(inspectionType)}
        selected={!!selectedIds.find((id) => id === inspectionType.id)}
        showCheckbox={true}
        expanded={true}
        headerInfo={inspectionTypeName(onActionSelect, t)(
          inspectionType.name,
          inspectionType.id
        )}
      >
        <InspectionTypeCardDetails {...inspectionType} templateName={templateName} canUseInspectionIssuesWithWorkflow={canUseInspectionIssuesWithWorkflow} />
      </ExpandableCard>
      )
  });
  };

  return (
    <Wrapper>
      {groupBy.groupByColumns.map((groupbyheader, i) => {
        const groupOfCards = getGroupOfCards(
          queryData,
          groupbyheader.group,
          groupBy.accessor,
          !!groupbyheader.isNew
        );

        const isLast =
          groupBy.groupByColumns[groupBy.groupByColumns.length - 1] !== ''
            ? groupBy.groupByColumns.length - 1
            : groupBy.groupByColumns.filter((e) => e !== '').length - 1;

        return (
          <ExpandableGroupHeader
            key={`groupheader-${groupbyheader.group}`}
            selectGroupOfItems={selectItems(groupOfCards)}
            groupIsSelected={groupCheckStatus(groupOfCards)}
            collapsed={
              !!groupBy?.collapsedGroups?.find((e) => e === groupbyheader.group)
            }
            label={groupbyheader.group}
            isLast={isLast === i}
          >
            <CardsWrapper>{renderCards(groupOfCards)}</CardsWrapper>
          </ExpandableGroupHeader>
        );
      })}
    </Wrapper>
  );
};

export default InspectionTypeCardList;
